import {Confirm, useOpenModal} from '@/components/Modal/index.mjs'
import {useMapContext} from '@/components/MindMap/index.mjs'

export default () => {
    const openModal = useOpenModal()
    const map = useMapContext()

    if (! (
        map.permission.has('revise') &&
        'REVISE' === map.dp.stsCode
    )) {
        return null
    }

    const onClick = async () => {
        const isConfirmed = await openModal(
            <Confirm>
                确定撤销修订？（撤销修订后，模型将恢复至最近一次发布版）
            </Confirm>
        )

        if (isConfirmed) {
            map.undoRevise()
        }
    }

    return {
        key: 'undo-revise-product',
        label: '撤销修订',
        onClick,
    }
}
